import Support from '../../utils/supporter'
import Cookie from '../../utils/cookie'
import MptcfeUtils from 'mptcfe-utils'
import Util from '../../utils/util'

const CallApp = MptcfeUtils.CallApp

/**
 * @description 判断唤起APP是否成功的延时时间
 */
const CALLAPPDELAYTIME = 2 * 1000

/**
 * @description 唤起APP的上报参数
 */
const CallAppAcode = 9541
const referrer = document.referrer || ''
/**
 * @description 唤起行为参数，包括可唤起、打开弹窗、点击取消、点击打开、唤起成功、唤起失败，取callAction参数的值
 */
const CallActionCodeMap = {
    "isAbleCall": "1",
    "openPopup": "2",
    "popupCancel": "3",
    "popupConfirm": "4",
    "callSuccess": "5",
    "callFail": "6",
    "isDirectAbleCall": "7",
}

/**
 * @description 手机条件：非IOS
 */
const phoneConditions = !Support.os.ios

/**
 * @description 浏览器条件，不是微信、UC、百度,搜狐网app，搜狐资讯app，搜狐新闻app
 */
 const browserConditions = !Support.isUC && !Support.isBaiduBoxApp && !Support.isWeixin && !Support.isMSOHU && !Support.isSohuNews && !Support.isSohuInfo

/**
 * @description 直接唤起登录的手机条件，目前是非iOS手机均可执行
 */
const directCallAppPhoneConditions = !Support.os.ios

/**
 * @description 是否为站内转化
 */
const isSohuWebsite = document.referrer.indexOf('sohu.com') > -1

/**
 * @description 设置判断是否可唤起APP的先决条件，是否为非直访，非站内转化
 */
const isAbleCallAppCondition = document.referrer && !(document.referrer.indexOf('sohu.com') > -1)

/**
 * @description 满足可唤起APP的先决条件，则设置cookie，二跳时进行唤起
 */
if(isAbleCallAppCondition) Cookie.set("isAbleCallAppConditionResource", "isAbleCallAppConditionResource", 60 * 60 * 1000)

/**
 * @description 满足可唤起APP的先决条件，且是二跳时
 */
const isAbleCallAppConditionResource = Cookie.get("isAbleCallAppConditionResource") === 'isAbleCallAppConditionResource' ? true : false

// 在Safari浏览器中
const isInSafari = navigator.userAgent && (navigator.userAgent.match(/Safari/g))
// 搜索来源
const isFromSearch = Util.isFromSearch()

// 站内跳转&&不是文章页
const isSohuNotArticle = referrer.includes('sohu.com') && !referrer.includes('/a/')

// 部分渠道来源
const isFromSomeTrans = function() {
    if(!referrer) return false
    const transList = ['_trans_=000011_hwzy_','_trans_=000012_uc _','_trans_=000012_qq_','_trans_=000012_wm_']
    for(let i = 0; i < transList.length; i++) {
        if(referrer.includes(transList[i])) return true
    }
    return false
}()
// 移动端
const isMobile = function(){
    const ua = navigator.userAgent.toLowerCase()
    return !!(ua.match(/AppleWebKit.*Mobile.*/) || /iphone|ipad|ipod|android/.test(ua))
}()

// （站内跳转|直访|搜索来源） && 不是ios && 排除部分渠道来源 && 是mobile
const isAbleCallApp = (isSohuNotArticle || !referrer || isFromSearch) && phoneConditions && !isFromSomeTrans && isMobile

setTimeout(() => {
    isAbleCallApp && MptcfeUtils.Utils.sendSpmAction(CallAppAcode, `callAction:${CallActionCodeMap.isAbleCall}`)
}, 1000)

export default {
    isAbleCallApp: isAbleCallApp,
    DirectCallApp: function(url){
        /**
         * @description 对应上报参数，callId
         */
        let _callUniqueId = MptcfeUtils.Utils.getPvId()

        //生成唤起URL
        url += `&startfrom=4221deeplink${_callUniqueId}`

        //唤起APP操作
        new CallApp({
            protocol : {
                intent: url,
                schema: url,
                universalLink:  url,
            },
            timeout: CALLAPPDELAYTIME,
            fail: () => {
                //失败回调
                MptcfeUtils.Utils.sendSpmAction(CallAppAcode, `callAction:${CallActionCodeMap.callFail};callId:${_callUniqueId}`)
            },
            successFn: () => {
                //成功回调
                MptcfeUtils.Utils.sendSpmAction(CallAppAcode, `callAction:${CallActionCodeMap.callSuccess};callId:${_callUniqueId}`)
            }
        }).call()
    },
    /**
     * @description 唤起APP的能力
     * @param {*} url 唤起的url
     * @param {*} successFn
     * @param {*} errorFn
     */
    CallApp: function(url, successFn){

        /**
         * @description 对应上报参数，callId
         */
        let _callUniqueId = MptcfeUtils.Utils.getPvId()

        //生成唤起URL
        url += `&startfrom=4221deeplink${_callUniqueId}`

        //点解弹窗时间
        MptcfeUtils.Utils.sendSpmAction(CallAppAcode, `callAction:${CallActionCodeMap.openPopup};callId:${_callUniqueId}`)

        //唤起APP操作
        new CallApp({
            protocol : {
                intent: url,
                schema: url,
                universalLink:  url,
            },
            timeout: CALLAPPDELAYTIME,
            fail: () => {
                //失败回调
                MptcfeUtils.Utils.sendSpmAction(CallAppAcode, `callAction:${CallActionCodeMap.callFail};callId:${_callUniqueId}`)
            },
            successFn: () => { }
        }).call()
        
        // 判断页面是否隐藏，若隐藏则为跳转成功
        setTimeout(()=>{
            if(document && document.hidden) {
                MptcfeUtils.Utils.sendSpmAction(CallAppAcode, `callAction:${CallActionCodeMap.callSuccess};callId:${_callUniqueId}`)
            }
        },CALLAPPDELAYTIME)
        //直接调用成功回调
        successFn()
    }
}